import { useEffect, useState } from "react";

import { FetchError } from "utils/errors";

import getFlowsLinkConfirmErrorMessage from "./getErrorMessage";

type FlowsLinkInfo = {
  flowsOrganizationName: string;
  flowsBaseUrl: string;
};

type UseFlowsLinkConfirmInfoResult = {
  info: FlowsLinkInfo | undefined;
  isLoading: boolean;
  loadError: string | undefined;
};

const useFlowsLinkConfirmInfo = (token: string): UseFlowsLinkConfirmInfoResult => {
  const [info, setInfo] = useState<FlowsLinkInfo>();
  const [loadError, setLoadError] = useState<string>();

  useEffect(() => {
    fetch(`/flows/link/info?token=${encodeURIComponent(token)}`)
      .then(async (response) => {
        if (!response.ok) {
          throw new FetchError(response.status, (await response.text()).trim());
        }

        return response.json();
      })
      .then((data: FlowsLinkInfo) => setInfo(data))
      .catch((error: unknown) => {
        setLoadError(getFlowsLinkConfirmErrorMessage(error));
      });
  }, [token]);

  const isLoading = !info && !loadError;

  return { info, isLoading, loadError };
};

export default useFlowsLinkConfirmInfo;
